<template>
    <b-modal
        hide-footer
        id="info-application"
        title="Application"
        v-model="visible"
        size="md"
    >
        <p>Select the application in which you will be working. Please note that tire air inflation pressure may vary from one application to the next. So, run a calculation for each application.</p>
    </b-modal>
</template>

<script>
export default {
    data: () => ({
        visible: false,
    }),
}
</script>
